export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-559338b0',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
};
